(function($) {
	$(function() {
		if($("#filterproducts").length){
			$("#filterproducts").on('keyup',function(){
				$(".pricelisttable tr:not(.topheader)").each(function(){
					contains = false;

					searchterm = $("#filterproducts").val().toLowerCase();
					name = $(this).html().toLowerCase();
					if(name.indexOf(searchterm) > -1){
						contains = true;
					}

					if(contains){
						$(this).addClass('inheader');
						$(this).removeClass('notheader');
					}else{
						$(this).removeClass('inheader');
						$(this).addClass('notheader');
					}

				});
			});
			
			$(".pricelisttable").addClass('filtered');

			$("#filterproducts").trigger('keyup');

			$('.price-list-download').each(function(e) {
				$(this).prop('data-link', $(this).prop('href'));
			});

			$('.price-list-download').on('click', function(e) {
				var searchterm = $('#filterproducts').val();
				var tablerows = $('tr.inheader').length;
				if( tablerows > 0 ) {
					if( searchterm === "" ) {
						$(this).prop('href', $(this).prop('data-link') );
						return true;
					}else{
						//e.preventDefault();
						$(this).prop('href', $(this).prop('data-link')+'/'+searchterm );
						return true;
					}
				}else{
					alert('Your search term has no results.');
					e.preventDefault(); return false;
				}
			});
		}

		$(".addressdetails").on('click',function(event){
			event.preventDefault();
		});
		$("#createcontacttoggle").on('click',function(){
			$("#createcontactcontainer").slideDown(200);
			$("select[name=ow_contact_id]").hide();
			//console.log($("input[name=ow_contact_id]"));


			$("#newlink").slideUp(200);
			$("#oldlink").slideDown(200);
			$("input[name=new_conatct]").val(1);

		});
		$("#preselectedcontacttoggle").on('click',function(){
			$("#createcontactcontainer").slideUp(200);
			$("select[name=ow_contact_id]").show();
			//console.log($("input[name=ow_contact_id]"));
			$("#oldlink").slideUp(200);
			$("#newlink").slideDown(200);
			$("input[name=new_conatct]").val(0);

		});

		isnew = $('input[name=new_conatct]').val();
		if(isnew == 1){
			$("#createcontacttoggle").trigger('click');
		}else{
			$("#preselectedcontacttoggle").trigger('click');
		}

		//reset content height if footer is present
		function showFooter() {
			if( $('footer').length > 0 ) {
				var footerHeight = parseFloat($('footer').outerHeight(true));
				var contentMinHeight = parseFloat($('.content-wrapper').css('min-height'));
				$('.content-wrapper').css({ 'min-height': contentMinHeight-footerHeight });
			}
		}
		showFooter();

		$(window).on('resize', function() {
			showFooter();
		});


	}); 

	$(function() {
		$('.orderdetails').addClass('hiderows');
		$('.orderpolink').on('click',function(){
			$(this).parents('.orderdetails').toggleClass('hiderows');
			var readmore = $(this).find('.po-read-more').text();
			if(readmore == 'Read More') {
				$(this).find('.po-read-more').text('Read Less');
			}else{
				$(this).find('.po-read-more').text('Read More');
			}
		});
		if(orderid = getQueryVariable('orderid')){
			$('#order'+orderid).trigger('click');
			//$("body").delay(500).scrollTop($('#order'+orderid).offset().top);
		}
	}); 

	$('.adddeliveryprice').on('click',function(){
		$(this).parent().siblings('.priceformholder').removeClass('hide');
		//console.log();
		$(this).parent().addClass('hide');
	});


	//remove admin users for direct orders
	$('input[name=perms\\[\\]][value=orders\\.create]').on('change',function() {
		if($(this).prop( "checked" )){
			$("#approvaluserbox").slideUp(200);
		}else{
			$("#approvaluserbox").slideDown(200);
		}
	});
	$('input[name=perms\\[\\]][value=orders\\.create]').trigger('change');
	//orders.create
	//approvaluserbox
	//perms[]

	//Select all addresses
	var checked = $('input[name="addresses[]"]:checked').length;
	if(checked > 0) {
		$('.select-all-addresses a').addClass('selected').html('<i class="fa fa-times"></i> Select None');
	}
	$('.select-all-addresses a').on('click', function(e) {
		if( $(this).hasClass('selected') ) {
			$(this).html('<i class="fa fa-check"></i> Select All');
			$('input[name="addresses[]"]').removeAttr('checked');
		}else{
			$(this).html('<i class="fa fa-times"></i> Select None');
			$('input[name="addresses[]"]').prop('checked', 'checked');
		}
		$(this).toggleClass('selected');
		e.preventDefault(); return false;
	});




	$(function() {
		$('#discounttype').on('change',function(){
			if($(this).val() == 1){
				$('#moneyoffholder').show();
				$('#percentoffholder').hide();
			}else if($(this).val() == 2){
				$('#moneyoffholder').hide();
				$('#percentoffholder').show();
			}
		});
		$('#discounttype').trigger('change');
	}); 

	$(function() {
		$('.quantitypending').on('input',function(){
			$('#quantchangewarning').slideDown(100);
		});
	}); 

	$(function() {
		resize_invoice_boxes();		
	}); 
	$(window).resize(function(){
		resize_invoice_boxes();
	});

	function resize_invoice_boxes(){
		$('.invoicerow').each(function(){
			var mh = 0;
			$('.panel-invoice',this).css('min-height',(0));
			$('.panel-invoice',this).each(function(){

				if($(this).height() > mh){
					mh = $(this).height();
				}
			});
			$('.panel-invoice',this).css('min-height',(mh+30));

		});		
	}

	$('a[href^="mailto:"]').click(function(){
		var mailto=jQuery(this).attr('href');
		ga('send', 'event', 'contact', 'mailto', mailto);
	});


	$('.fave-help').on('click', function(e) {
		$('.fave-help-wrap .inner').slideToggle();
		e.preventDefault(); return false;
	});

	$('.internal-user').on('click', function(e) {
        if( $(this).is(':checked') ) {
            $('.password-group').slideDown('fast');
        }else{
            $('.password-group').slideUp('fast');
        }
    });


})(jQuery);

function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false); 
}

;( function(window, document, $, undefined) {
	let _document = $(document),
		_window = $(window),
		_body = $('body'),
		appVH = _window.height(),
		appVW = _window.width(),
		ClickOrTouchEvent = ("ontouchend" in document.documentElement ? "touchend" : "click");

	$(function() {

		/**
		 * Checks if variable is empty
		 * @param  {mixed}  elem 	Variable to check
		 * @return {Boolean}      	Returns true if empty and false if not
		 */
		function isEmpty(elem) {
			return (
				elem === ''
				|| elem === null
				|| elem == undefined
				|| (elem.hasOwnProperty('length') && elem.length === 0)
				|| (typeof elem === 'object' && Object.keys(elem).length === 0)
				|| (typeof elem === 'number' && isNaN(elem))
			);
		}

		/*========================================================================*\
		|------------------------------| Invoices |---------------------------------|
		\*========================================================================*/

		/*=============================| Date Picker |================================*/
		let dateFormat = "yy/mm/dd",
			from = $( "#from" ).datepicker({
				dateFormat: "yy/mm/dd",
				defaultDate: "+1w",
				changeMonth: true
				// numberOfMonths: 3
			})
			.on( "change", function() {
				to.datepicker( "option", "minDate", getDate( this ) );
			}),
			to = $( "#to" ).datepicker({
				dateFormat: "yy/mm/dd",
				defaultDate: "+1w",
				changeMonth: true
				// numberOfMonths: 3
			})
			.on( "change", function() {
				from.datepicker( "option", "maxDate", getDate( this ) );
			});

		function getDate( element ) {
			let date;
			try {
				date = $.datepicker.parseDate( dateFormat, element.value );
			} catch( error ) {
				date = null;
			}

			return date;
		}

		/*=============================| Type Select |================================*/
		$('#invoice-type-select').on('typeSelect.typeSelect', function() {
			let $this = $(this),
				type = $this.val(),
				$target = $('#' + type);

			if( !$target.hasClass('active') ) {
				//Activate current
				$target.addClass('active')
					.find('input')
					.removeAttr('disabled', 'disabled');
			}

			//Deactive siblings
			$target.siblings('.invoice-search-types')
				.removeClass('active')
				.find('input')
				.attr('disabled', 'disabled');
		});

		$('#invoice-type-select').on('change.typeSelect', function() {
			$(this).trigger('typeSelect.typeSelect');
		});

		_window.on('load.typeSelect', function() {
			let $typeSelect = $('#invoice-type-select'),
				$types = $('.invoice-search-types');

			if( !$types.hasClass('active') ) {
				let type = $typeSelect.attr('data-current-type');
				$typeSelect.children('option[value="'+ type +'"]').prop('selected', true);
			}
			$typeSelect.trigger('typeSelect.typeSelect');
		});

		/*========================================================================*\
		|-----------------------------| Check All |--------------------------------|
		\*========================================================================*/
		_document.on('click.checkAll', 'input.check-all', function() {
			let $this = $(this),
				value = $this.prop('checked'),
				checkFor = $this.attr('data-check-for'),
				$checks = $('.' + checkFor),
				checksLength = $checks.length;

			for(let i = 0; i < checksLength; i++) {
				let $check = $($checks[i]);

				if($check.attr('type') != 'checkbox') {
					$check = $check.find('input[type="checkbox"]');
				}

				let checkVal = $check.prop('checked');
				if(value != checkVal) {
					$check.prop('checked', value)
				}
			}
		});

		$('input[value="addresses.auto"]').on('change', function() {
			if( $(this).is(':checked') ) {
				$('.all-addresses').removeClass('hidden');
				$('.select-all-addresses, .addresses-wrap').addClass('hidden');
			}else{
				$('.all-addresses').addClass('hidden');
				$('.select-all-addresses, .addresses-wrap').removeClass('hidden');
			}
		})

		/*========================================================================*\
		|-----------------------------| Summernote |--------------------------------|
		\*========================================================================*/
		if($('.sn').length) {
			let $sn = $('.sn');

			$sn.summernote({
				toolbar: [
					// [groupName, [list of button]]
					['style', ['bold', 'italic', 'underline', 'clear']],
					['font', ['strikethrough', 'superscript', 'subscript']],
					['fontsize', ['fontsize']],
					['color', ['color']],
					['para', ['ul', 'ol', 'paragraph']],
					['height', ['height']],
					['picture']
				],
				callbacks: {
					onImageUpload: function(files) {
						editor = $(this);
						snSendFile(files[0], editor);
					}
				}
			});
		}

		/**
		 * Sends file upload from summernote to landing page images
		 * @param  {Array} file
		 * @param  {Object} editor
		 * @return {Void|false}
		 */
		function snSendFile(file, editor) {
			let $editor = $(editor),
				$form = $editor.closest('form');

			if(!$form.length) {
				return false;
			}

			let data = new FormData(),
				url = $form.attr('action') + '/store-image',
				token = $form.find('input[name="_token"]').val();

			data.append("lp_image", file);
			data.append("_token", token);

			$.ajax({
				data: data,
				type: "POST",
				url: url,
				cache: false,
				contentType: false,
				processData: false,
				success: function(data) {
					let image = $('<img>').attr('src', data.image_url);
					$editor.summernote("insertNode", image[0]);
				}
			});
		}

		/*========================================================================*\
		|-------------------------| Customer Journeys |----------------------------|
		\*========================================================================*/

		$('#customer-journey-form .panel-body .customer-journey-image button.remove-image').on(ClickOrTouchEvent, function (e) {
			let conf = confirm('Are you sure?');

			if (conf) {
				let $this = $(this),
					$parent = $this.parent('.image-container'),
					$input = $parent.find('.image-current-input'),
					$img = $parent.find('img');

				$input.val("");
				$img.remove();
				$this.after('<div class="alert alert-warning">Please save the page to fully remove the image.</div>');
				$this.remove();
			}
		});

		$('#customer-journey-form .panel-heading .rule-active button.active_button').on(ClickOrTouchEvent, function (e) {
			let $this = $(this),
				$input = $this.next('.rule-active-input'),
				$parent = $this.closest('.panel-rule'),
				value = parseInt($input.val());

			if (value) {
				$input.val(0);
				$this.removeClass('active');
				$this.removeClass('btn-success');
				$this.addClass('btn-danger');
				$this.html('Disabled');
				$this.attr('title', 'Activate');

				//Parent
				$parent.removeClass('active');
				$parent.removeClass('panel-success');
				$parent.addClass('panel-danger');
			} else {
				$input.val(1);
				$this.addClass('active');
				$this.addClass('btn-success');
				$this.removeClass('btn-danger');
				$this.html('Active');
				$this.attr('title', 'Disable');

				//Parent
				$parent.addClass('active');
				$parent.addClass('panel-success');
				$parent.removeClass('panel-danger');
			}
		});
	});
})(window, document, window.jQuery);
